import { useEffect, useState } from "react";
import { errorToast, succToast } from "../../../Utils/Toast/Toast";
import {  Modal } from "react-bootstrap";
import TableFixedPage from "../../TableFixedPage/TableFixedPage";
import VehicleListTabel from "../../Tables/Vehicle/VehicleListTabel";
import {  ColorAPI, getColorListAPI } from "../../../Api/PanelAdminServices";
import Button from "../../Button/Button";
import ColorListTabel from "../../Tables/Color/ColorListTabel";
const ColorListContainer = () => {
  /////////get data //////
  const [ColorListState, setColorState] = useState([]);
  const [disable, setDisable] = useState(false);
  const [ColorDetail, setColorDetail] = useState();
  useEffect(() => {
    DeliverList();
  }, []);
  const DeliverList = async () => {
    getColorListAPI((succ,res)=>{
      if(succ){
        if(res.status===0){
          errorToast("مشکلی پیش آمده است")
        }else{
          setColorState(res.colors);  
        }
      }else{
        errorToast("خطایی در سرور رخ داده است")
      }
    })
  };
  const [deleteVisible, setDeleteVisible] = useState(false);
 


  const modalHandler = (data) => {
    setColorDetail(data)
    setDeleteVisible(true);
  };
  const handleOkAddress = () => {
    setDeleteVisible(false);
  };

  const deleteVehicleHandler=()=>{
    setDisable(true)
    let info={
      model:data.model,
      action:'delete',
      id:ColorDetail.key
  }
  ColorAPI(info,(succ,res)=>{
      if(succ){
        setDisable(false)
          if(res.status===1){
              succToast('انجام شد!')
              DeliverList()
              handleOkAddress()
            }else{
              errorToast(res.message)
            }
      }else{
          console.log(res)
          setDisable(false)
      }
  })

  }


  const TitleStyle = {
    width: "100%",
    color: "#c20c64",
    textAlign: "center",
    fontSize:'1rem'
  };

  const data =
  ColorListState &&
  ColorListState.map((item) => {
    return {
      key: item.id,
      color: item.color,
    };
  });
  return (
    <div>
      <Modal show={deleteVisible} onHide={handleOkAddress}>
        <Modal.Header>
          <Modal.Title style={TitleStyle}>
            آیا از حذف کردن وسیله نقلبه موردنظر مطمئن هستید؟
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "space-around",
            }}
          >
            <Button
              ClassBtn={"rejectBtn"}
              Value={"خیر"}
              ClickHandler={handleOkAddress}
            />
            <Button
              ClassBtn={"confirmBtn"}
              Value={"بله"}
              ClickHandler={deleteVehicleHandler}
              disabledprops={disable}
            />
          </div>
        </Modal.Body>
      </Modal>

      <TableFixedPage title="لیست رنگ ها" />
      {/* <VehicleListTabel modalHandler={(data)=>modalHandler(data)} data={data} /> */}
      <ColorListTabel modalHandler={(data)=>modalHandler(data)} data={data} />
    </div>
  );
};

export default ColorListContainer;
